export const environment = {
  production: true,
  baseUrl: 'https://jeppisinvest-backend.imsd.ateafinland.fi',
  frontendUrl: 'https://laskuri.jeppisinvest.fi/'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts